import { defineComponent, h, useAttrs } from 'vue'
import { RouterLink } from 'vue-router'

function normalizeItem(item) {
  if (item == null || typeof item !== 'object') {
    return {
      title: item == null ? '' : String(item),
      to: null
    }
  }

  return {
    ...item,
    title: item.title ?? item.text ?? '',
    to: item.to ?? item.href ?? null
  }
}

function renderItem(item) {
  if (!item.to) return h('span', item.title)

  return h(
    RouterLink,
    {
      custom: true,
      to: item.to
    },
    {
      default: ({ href, navigate }) =>
        h(
          'a',
          {
            href,
            onClick: navigate
          },
          item.title
        )
    }
  )
}

export default defineComponent({
  name: 'VBreadcrumbsCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  props: {
    divider: {
      type: String,
      default: '/'
    },
    items: {
      type: Array,
      default: () => []
    }
  },

  setup(props) {
    const attrs = useAttrs()

    return () => {
      const items = props.items.map(normalizeItem)
      const children = []

      items.forEach((item, index) => {
        if (index > 0) {
          children.push(
            h(
              'li',
              {
                class: 'v-breadcrumbs__divider',
                key: `divider-${index}`
              },
              props.divider
            )
          )
        }

        children.push(
          h(
            'li',
            {
              class: {
                'v-breadcrumbs__item': true,
                'v-breadcrumbs__item--disabled': !item.to
              },
              key: `item-${index}`
            },
            renderItem(item)
          )
        )
      })

      return h(
        'ul',
        {
          ...attrs,
          class: ['v-breadcrumbs', attrs.class]
        },
        children
      )
    }
  }
})
